import clsx from 'clsx'
import React from 'react'

import './Tabs.scss'

const Tabs = ({ className, current, options, onTabChange, isDarkTheme }) => {
   return (
      <div className={clsx('Tabs', isDarkTheme && 'Tabs--dark', className)}>
         {options.map(option => (
            <span
               key={option}
               className={clsx(
                  'Tabs__tab',
                  current === option && 'Tabs__tab--active'
               )}
               onClick={() => onTabChange(option)}
            >
               {option}
            </span>
         ))}
      </div>
   )
}

export default Tabs
